module.exports = __webpack_public_path__ + "img/543320ae40c21d0b6df6d6a332e35ed1.png";